"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationSelect = exports["default"] = exports.sorterByLabel = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _qs = _interopRequireDefault(require("qs"));

var _reactI18next = require("react-i18next");

var _rcSelect = _interopRequireDefault(require("rc-select"));

var _dictionaries = require("../../constants/dictionaries");

var _withFieldWrapper = _interopRequireDefault(require("../hocs/withFieldWrapper"));

var _withLocationValues = _interopRequireDefault(require("../hocs/withLocationValues"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = {
  "formWrapper": "index__formWrapper",
  "formBtn": "index__formBtn",
  "formBtnCancel": "index__formBtnCancel",
  "formLink": "index__formLink",
  "withoutOpd": "index__withoutOpd",
  "formLabel": "index__formLabel",
  "formLabelRequired": "index__formLabelRequired",
  "formLabelOptional": "index__formLabelOptional",
  "formInput": "index__formInput",
  "formTextarea": "index__formTextarea",
  "formSection": "index__formSection",
  "formSectionRow": "index__formSectionRow",
  "formSectionBtn": "index__formSectionBtn",
  "error": "index__error",
  "compositeError": "index__compositeError",
  "fileInput": "index__fileInput",
  "fileControls": "index__fileControls",
  "formDateSelect": "index__formDateSelect",
  "formMoneySelect": "index__formMoneySelect",
  "amountField": "index__amountField",
  "currencyField": "index__currencyField",
  "imagePreview": "index__imagePreview",
  "dangerBtn": "index__dangerBtn",
  "dangerBtnDisabled": "index__dangerBtnDisabled",
  "fileList": "index__fileList",
  "fileItem": "index__fileItem",
  "downloadButton": "index__downloadButton",
  "downloadButtonDisabled": "index__downloadButtonDisabled",
  "fileButtonGroup": "index__fileButtonGroup",
  "timeIndicator": "index__timeIndicator",
  "modalButtonGroup": "index__modalButtonGroup"
};

var sorterByLabel = function sorterByLabel(optionA, optionB) {
  return optionA.label.localeCompare(optionB.label);
};

exports.sorterByLabel = sorterByLabel;

var Select = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Select);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "fetchDictionary", function () {
      var _this$props = _this.props,
          dictionaryType = _this$props.dictionaryType,
          getDictionary = _this$props.getDictionary;

      if ((0, _ramda.contains)(dictionaryType, _dictionaries.GEO_DICTIONARIES_TYPES)) {
        getDictionary(dictionaryType, 'items', _qs["default"].stringify({
          pagination: JSON.stringify({
            limit: 0
          })
        }, {
          addQueryPrefix: true
        }));
      } else if (dictionaryType) {
        getDictionary(dictionaryType);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (value) {
      var _this$props2 = _this.props,
          settings = _this$props2.settings,
          onChange = _this$props2.onChange;
      var multiple = (0, _ramda.path)(['multiple'], settings);

      if (multiple) {
        onChange(value && value.length ? value : undefined);
      } else {
        var userValueQuestion = _this.getUserValueQuestion().value;

        onChange(_this.allowUserValue() && value === userValueQuestion ? undefined : value);
        _this.allowUserValue() && _this.setState({
          other: value === userValueQuestion
        });
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChangeOther", function (e) {
      _this.props.onChange(e.target.value ? {
        value: 'Иное',
        userValue: e.target.value
      } : undefined);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getUserValueQuestion", function () {
      var value = _this.props.settings.userValueQuestion || _this.props.t('otherOption');

      return {
        label: value,
        value: value
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "allowUserValue", function () {
      return _this.props.settings.userValueAllowed && !_this.props.settings.multiple;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getOptions", function () {
      var _this$props3 = _this.props,
          settings = _this$props3.settings,
          options = _this$props3.options,
          formValues = _this$props3.formValues;
      var regionParent = (0, _ramda.prop)(settings.regionField, formValues);
      var countryParent = (0, _ramda.prop)(settings.countryField, formValues);
      var filteredOptions = (0, _ramda.filter)((0, _ramda.allPass)([function (item) {
        if (countryParent || regionParent) {
          var regionEqual = regionParent ? regionParent === item.region : true;
          var countryEqual = countryParent ? countryParent === item.country : true;
          return regionEqual && countryEqual;
        } else {
          return true;
        }
      }, function (item) {
        if ((0, _ramda.prop)('length', settings.countries) || (0, _ramda.prop)('length', settings.regions)) {
          return (0, _ramda.contains)(item.region, settings.regions || []) || (0, _ramda.contains)(item.country, settings.countries || []);
        } else {
          return true;
        }
      }, function (item) {
        if (settings.selection && settings.selection.length) {
          return (0, _ramda.contains)(item.value, settings.selection) || (0, _ramda.contains)(item.internalId, settings.selection);
        } else {
          return true;
        }
      }]), options);
      return _this.allowUserValue() ? [].concat((0, _toConsumableArray2["default"])(filteredOptions), [_this.getUserValueQuestion()]) : filteredOptions;
    });
    _this.state = {
      other: props.settings.userValueAllowed && !props.settings.multiple && props.input.value === (props.settings.userValueQuestion || 'Другое')
    };
    _this.selectContainer = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.dictionaryType) {
        this.fetchDictionary();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prev) {
      var _this$props4 = this.props,
          settings = _this$props4.settings,
          formValues = _this$props4.formValues,
          required = _this$props4.required,
          toggleRequired = _this$props4.toggleRequired,
          fieldsWithoutValidation = _this$props4.fieldsWithoutValidation,
          changeFieldValidation = _this$props4.changeFieldValidation,
          name = _this$props4.input.name,
          propsOptions = _this$props4.options;
      var options = this.getOptions();

      if (formValues && (!(0, _ramda.equals)(formValues[settings.regionField], prev.formValues[prev.settings.regionField]) || !(0, _ramda.equals)(formValues[settings.countryField], prev.formValues[prev.settings.countryField]))) {
        this.onChange(undefined);
      }

      var newRequiredStatus = !(0, _ramda.isEmpty)(options);

      if (newRequiredStatus !== required) {
        toggleRequired(newRequiredStatus);
      }

      if (fieldsWithoutValidation[name] !== (0, _ramda.isEmpty)(options) && !(0, _ramda.isEmpty)(propsOptions)) {
        changeFieldValidation(name, (0, _ramda.isEmpty)(options));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          _this$props5$input = _this$props5.input,
          value = _this$props5$input.value,
          name = _this$props5$input.name,
          settings = _this$props5.settings,
          errors = _this$props5.errors,
          dictionaryType = _this$props5.dictionaryType,
          t = _this$props5.t,
          disabled = _this$props5.disabled;
      var multiple = (0, _ramda.path)(['multiple'], settings);
      var placeholder = (0, _ramda.path)(['placeholder'], settings);
      var options = this.getOptions() || [];
      var isError = errors[dictionaryType];
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.selectContainer,
        id: "".concat(name, "-select")
      }, /*#__PURE__*/_react["default"].createElement(_rcSelect["default"], (0, _extends2["default"])({
        id: name,
        key: value,
        value: (this.allowUserValue() && this.state.other ? this.getUserValueQuestion().value : value) || undefined,
        onChange: this.onChange,
        showSearch: options.length > 10,
        optionFilterProp: "label",
        placeholder: placeholder,
        notFoundContent: t('noOptionsMessage'),
        prefixCls: "jobot-forms-rc-select",
        disabled: disabled,
        options: options,
        mode: multiple ? 'multiple' : 'single'
      }, isError ? {
        open: false
      } : {}, {
        virtual: true,
        allowClear: true,
        showArrow: true,
        getPopupContainer: function getPopupContainer() {
          return _this2.selectContainer.current;
        }
      })), this.allowUserValue() && this.state.other && /*#__PURE__*/_react["default"].createElement("input", {
        className: "input ".concat(styles.formInput),
        style: {
          marginTop: 10
        },
        value: (0, _ramda.pathOr)('', ['userValue'], value),
        onChange: this.onChangeOther
      }));
    }
  }]);
  return Select;
}(_react.Component);

var SelectComponent = (0, _withFieldWrapper["default"])((0, _reactI18next.withTranslation)()(Select));
var _default = SelectComponent;
exports["default"] = _default;
var LocationSelect = (0, _withLocationValues["default"])(SelectComponent);
exports.LocationSelect = LocationSelect;